import { Stack } from 'expo-router';
import { staticPageKey } from '../../../constants/routeKeys';
import { title } from '../../../components/Root/title';
import { useStores } from '../../../hooks/useStores';

export default function Layout(){
  const {language} = useStores();
  const titles = language?.translate?.MOBILE?.PAGE_TITLE;

  return(<Stack
    screenOptions={{
      presentation: 'modal',
      gestureEnabled: false,
      contentStyle: { backgroundColor: '#fff' },
    }} >
    <Stack.Screen
      name={staticPageKey}
      options={() => ({
        headerBackTitleVisible: false,
        title: title(titles?.STATIC_PAGE),


      })}
    />
  </Stack>);
}
